import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { find, some } from 'lodash';
import { useFormDataContext, useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { useCampaignLevelConversionsApi } from 'services/api/campaignLevelConversionsApi';
import { useIsAppAccountNetwork } from '../../../../../../taboola-common-frontend-modules/account-configurations';

const emptyObj = [];
export const useClcInitialData = () => {
    const isNetworkAccount = useIsAppAccountNetwork();
    const {
        formAccount: { accountId },
    } = useFormDataContext();
    const { value: campaignId } = useFormFieldValue({ field: 'id' });
    const { getAccountLevelConversionRulesData, getCampaignLevelConversionRulesData } =
        useCampaignLevelConversionsApi();
    const { value: optimizedConversionRules } = useFormFieldValue({
        field: 'conversionRules.optimizedRules',
    });
    const { value: nonOptimizedConversionRules } = useFormFieldValue({
        field: 'conversionRules.nonOptimizedRules',
    });

    const { data = emptyObj } = useQuery(
        [campaignId, accountId, isNetworkAccount, 'clcRules'],
        () => {
            return campaignId && !isNetworkAccount
                ? getCampaignLevelConversionRulesData(accountId, campaignId)
                : getAccountLevelConversionRulesData(accountId);
        },
        {
            select: data => data?.results,
            refetchOnWindowFocus: false,
        }
    );

    const optimizedConversionRulesInitialData = useMemo(
        () =>
            data?.filter(item =>
                some(optimizedConversionRules, rule => item.apiUnipRuleConfiguration?.id === rule.id)
            ) ?? [],
        [data, optimizedConversionRules]
    );

    const nonOptimizedConversionRulesInitialData = useMemo(
        () =>
            data?.filter(item =>
                some(nonOptimizedConversionRules, rule => item.apiUnipRuleConfiguration?.id === rule.id)
            ) ?? [],
        [data, nonOptimizedConversionRules]
    );

    const accountDefaultRule = useMemo(() => find(data, { isDisabled: true })?.displayName, [data]);

    return { optimizedConversionRulesInitialData, nonOptimizedConversionRulesInitialData, accountDefaultRule };
};
